import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { Box } from '@mui/material'

import { FilterBox } from '../../../../ui'
import { APPS_FILTERS, APPS_GUILD_FILTERS, APPS_PRESCRIPTOR_FILTERS } from '../../constants'
import { appsFilterStyles } from './apps-filter.styles'
import { ExportToXLSBtn } from '../exporttoxls-btn/exporttoxls-btn.component'
import { useLocation } from 'react-router-dom'
export const AppsFilter = withStyles(appsFilterStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const combos = useSelector((state) => state.combos)
  const role = useSelector((state) => state.global.role)
  const location = useLocation()
  const currentSearch = new URLSearchParams(location.search)

  const roleFilters =
    role === 'gremio'
      ? APPS_GUILD_FILTERS
      : role === 'administrador_prescriptor'
        ? APPS_PRESCRIPTOR_FILTERS
        : APPS_FILTERS
  const data = roleFilters.map((item, i) => {
    if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
      if (item.comboId === 'tipo_vivienda') {
        item.values =
          combos[item.comboId] &&
          combos[item.comboId].data.map((el) => ({ key: el.value, value: el.value }))
      }
    }

    if (item.comboId === 'mercado' && item.name === 'mercado') {
      const tipoMercadoData = combos['tipo_mercado'] && combos['tipo_mercado'].data
      if (tipoMercadoData) {
        item.values = tipoMercadoData.map((el) => ({
          key: el.key,
          value: el.key,
        }))
      }
    }

    if (item.comboId === 'provincias' && item.values) {
      const ccaa = currentSearch.get('ccaa')
      if (ccaa) {
        item.values = item.values = item.values.filter((provincia) => {
          return -1 < ccaa.split(',').indexOf(provincia.ca)
        })
      }
    }
    return {
      ...item,
      label: formatMessage({
        id: 'pages.applications.filters.' + item.name + '.title',
      }),
    }
  })
  const buttonsComponent = (
    <Box display="flex" flexGrow={0.5} justifyContent="flex-end">
      <ExportToXLSBtn />
    </Box>
  )
  return <FilterBox filters={data}>{buttonsComponent}</FilterBox>
})
